import { render, staticRenderFns } from "./TicketColumnCard.vue?vue&type=template&id=7e65cc70&scoped=true"
import script from "./TicketColumnCard.vue?vue&type=script&lang=js"
export * from "./TicketColumnCard.vue?vue&type=script&lang=js"
import style0 from "./TicketColumnCard.vue?vue&type=style&index=0&id=7e65cc70&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e65cc70",
  null
  
)

export default component.exports